import { IFilter } from "@/models/tables";
import { FilterOperators, FilterTypes } from "@/data/table";
import i18n from "@/i18n";

const affiliateLinksFilters: IFilter[] = [
  {
    key: "name",
    label: i18n.t("_.name"),
    type: FilterTypes.STRING,
    operator: FilterOperators.CONTAINS
  },
  {
    key: "redirect_url",
    label: i18n.t("_.redirect_url"),
    type: FilterTypes.STRING,
    operator: FilterOperators.CONTAINS
  },
  {
    key: "visit_count",
    label: i18n.t("_.visits"),
    type: FilterTypes.NUMBER,
    operator: FilterOperators.EQUAL
  },
  {
    key: "referral_count",
    label: i18n.t("_.referrals"),
    type: FilterTypes.NUMBER,
    operator: FilterOperators.EQUAL
  },
  {
    key: "created_at",
    label: i18n.t("_.created"),
    type: FilterTypes.DATE,
    operator: FilterOperators.EQUAL
  }
];

const affiliateTiersFilters: IFilter[] = [
  {
    key: "name",
    label: i18n.t("_.name"),
    type: FilterTypes.STRING,
    operator: FilterOperators.CONTAINS
  },
  {
    key: "created_at",
    label: i18n.t("_.date_created"),
    type: FilterTypes.DATE,
    operator: FilterOperators.EQUAL
  }
];

const affiliatePayoutDestinationFilters: IFilter[] = [
  {
    key: "name",
    label: i18n.t("_.name"),
    type: FilterTypes.STRING,
    operator: FilterOperators.CONTAINS
  },
  {
    key: "created_at",
    label: i18n.t("_.date_created"),
    type: FilterTypes.DATE,
    operator: FilterOperators.EQUAL
  }
];

const AffiliateCommissionsFilters: IFilter[] = [
  {
    key: "created_at",
    label: i18n.t("_.date_created"),
    type: FilterTypes.DATE,
    operator: FilterOperators.EQUAL
  }
];

const AffiliatePayoutFilters: IFilter[] = [
  {
    key: "created_at",
    label: i18n.t("_.date_paid"),
    type: FilterTypes.DATE,
    operator: FilterOperators.EQUAL
  }
];

export {
  affiliateLinksFilters,
  affiliateTiersFilters,
  affiliatePayoutDestinationFilters,
  AffiliateCommissionsFilters,
  AffiliatePayoutFilters
};
